import React from 'react';
import { AssetLinks } from '@assets/assets';

interface FooterProps {
  text: string;
  text2?: string;
}

const Footer: React.FC<FooterProps> = ({ text, text2 }) => {
  return (
    <div className="iLendingCDX-footer">
      <span className="iLendingCDX-footer-divider">
        <img
          src={AssetLinks.check}
          className="iLendingCDX-footer-icon"
          alt="shield-icon"
        />
      </span>
      <h1 className="iLendingCDX-footer-text">{text}</h1>
      <h1 className="iLendingCDX-footer-text iLendingCDX-mt-2">{text2}</h1>
      <span className="iLendingCDX-footer-divider--full"></span>
    </div>
  );
};

export default Footer;
